import { apiDataManagerBaseURL } from '../../authentication/Global';
import { authenticationCentral } from '../../authentication/Authentication';
import { API, HTTPMethod, ContentType } from '../APICentral';

const eventsApiRoutes = {
    list: apiDataManagerBaseURL + "events/",
    create: apiDataManagerBaseURL + "events/",
    update: apiDataManagerBaseURL + "events/",
    associateToCalendar: apiDataManagerBaseURL + "events/associateToCalendar/",
    stopOnCalendar: apiDataManagerBaseURL + "events/stopOnCalendar/",
    delete: apiDataManagerBaseURL + "events/",
};

export class EventAPI {
    static list(provider = '') {
        const url = `${eventsApiRoutes.list}`

        return API.authenticatedRequest({
            url: provider === '' ? url : `${url}?provider=${provider}`,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static create(eventType, event) {
        const url = `${eventsApiRoutes.create}${eventType}`;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.POST,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(event)
        });
    }

    static update(type, id, event) {
        const url = `${eventsApiRoutes.update}${type}/${id}`;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.PUT,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(event)
        });
    }

    static associateToCalendar(id, event) {
        const url = `${eventsApiRoutes.associateToCalendar}${id}`;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.PUT,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(event)
        });
    }

    static stopOnCalendar(id, event) {
        const url = `${eventsApiRoutes.stopOnCalendar}${id}`;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.PUT,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(event)
        });
    }

    static delete(id) {
        const url = `${eventsApiRoutes.delete}${id}`;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.DELETE,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }
}
